import React, { useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// React Bootstrap
import { Form, Button, Col } from "react-bootstrap";

const FormDescripcionObra = ({ defaultValues, submissionHandler }) => {
  const [validated] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });

  // On submit del formulario
  const onSubmit = (data) => {
    submissionHandler(data);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Group as={Col} xs={12} md controlId="description-mission">
        <Form.Label>{"Descripción"}</Form.Label>
        <Form.Control
          name="description"
          as="textarea"
          placeholder={"Texto"}
          type="text"
          isInvalid={errors?.description}
          {...register("description", {
            maxLength: {
              value: 500,
              message: "El máximo de caracteres es 500",
            },
            required: "Este campo es obligatorio",
          })}
        />
        <ErrorMessage errors={errors} name="description" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
      </Form.Group>

      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormDescripcionObra;
